export const FIND_FILE_SUCCESS = 'FIND_FILE_SUCCESS';

export const findFileSuccess = file => ({
    type: FIND_FILE_SUCCESS,
    payload: { file },
});
